export { App as default } from '@guiker/investments-main-mfe'
